import { useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import TransactionDialog from "./transaction-dialog";
import { TransactionListDialog } from "./transaction-list-dialog";

const Dialogs = () => {
  const search = useSearch({
    from: Route.id,
  });

  if (search.modal === "transaction") {
    return <TransactionDialog />;
  }

  if (search.modal === "transaction-list") {
    return <TransactionListDialog />;
  }

  return null;
};

export { Dialogs };
